(function () {
  'use strict';

  function setProductionFile(form, name, file) {
    var input = Array.prototype.find.call(form.querySelectorAll('[data-production-file]'), function (item) { return item.name === 'properties[' + name + ']'; });
    if (!input) {
      input = document.createElement('input');
      input.type = 'file';
      input.hidden = true;
      input.name = 'properties[' + name + ']';
      input.setAttribute('data-production-file', '');
      form.appendChild(input);
    }
    var transfer = new DataTransfer();
    transfer.items.add(file);
    input.files = transfer.files;
  }

  function productionSignature(form, groups) {
    return JSON.stringify([groups.map(function (group) {
      return group.layers.map(function (layer) { return [layer.id, layer.url, layer.x, layer.y, layer.width, layer.height, layer.z]; });
    }), Array.prototype.map.call(form.querySelectorAll('input:not([type="file"]), select, textarea'), function (input) { return [input.name, input.value, input.checked]; })]);
  }

  function productionPNG(canvas, name) {
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (blob) {
        if (!blob || blob.size > 19000000) { reject(new Error('Print file is too large.')); return; }
        resolve(new File([blob], name, { type: 'image/png' }));
      }, 'image/png');
    });
  }

  function productionImage(url) {
    return new Promise(function (resolve, reject) {
      var image = new Image();
      image.onload = function () { resolve(image); };
      image.onerror = reject;
      image.src = url;
    });
  }

  function productionZIP(files) {
    return Promise.all(files.map(function (file) { return file.arrayBuffer(); })).then(function (buffers) {
      var parts = [], directory = [], offset = 0, directorySize = 0;
      files.forEach(function (file, index) {
        var bytes = new Uint8Array(buffers[index]);
        var name = new TextEncoder().encode(file.name);
        var crc = 0xffffffff;
        bytes.forEach(function (byte) {
          crc ^= byte;
          for (var bit = 0; bit < 8; bit++) crc = (crc >>> 1) ^ (0xedb88320 & -(crc & 1));
        });
        crc = (crc ^ 0xffffffff) >>> 0;
        var header = new Uint8Array(30 + name.length), h = new DataView(header.buffer);
        h.setUint32(0, 0x04034b50, true); h.setUint16(4, 20, true);
        h.setUint16(12, 33, true); h.setUint32(14, crc, true);
        h.setUint32(18, bytes.length, true); h.setUint32(22, bytes.length, true);
        h.setUint16(26, name.length, true); header.set(name, 30);
        var entry = new Uint8Array(46 + name.length), d = new DataView(entry.buffer);
        d.setUint32(0, 0x02014b50, true); d.setUint16(4, 20, true); d.setUint16(6, 20, true);
        d.setUint16(14, 33, true); d.setUint32(16, crc, true);
        d.setUint32(20, bytes.length, true); d.setUint32(24, bytes.length, true);
        d.setUint16(28, name.length, true); d.setUint32(42, offset, true); entry.set(name, 46);
        parts.push(header, bytes); directory.push(entry);
        offset += header.length + bytes.length; directorySize += entry.length;
      });
      var end = new Uint8Array(22), e = new DataView(end.buffer);
      e.setUint32(0, 0x06054b50, true); e.setUint16(8, files.length, true); e.setUint16(10, files.length, true);
      e.setUint32(12, directorySize, true); e.setUint32(16, offset, true);
      return new File(parts.concat(directory, [end]), 'creativemoro-print-files.zip', { type: 'application/zip' });
    });
  }

  function prepareProductionFiles(form, groups) {
    form.querySelectorAll('[data-production-file]').forEach(function (input) { input.remove(); });
    var snapshots = groups.filter(function (group) { return group.layers.length; }).map(function (group) {
      var rect = group.zone.getBoundingClientRect();
      if (!rect.width || !rect.height) throw new Error('Print area is not visible.');
      return { fit: group.fit, name: group.name, ratio: rect.width / rect.height, text: group.text, color: group.color, font: group.font,
        layers: group.layers.map(function (layer) { return { url: layer.url, type: layer.type, x: layer.x, y: layer.y, width: layer.width, height: layer.height, z: layer.z || 0 }; }) };
    });
    return (document.fonts ? document.fonts.ready : Promise.resolve()).then(function () {
      return Promise.all(snapshots.map(function (group) {
        var canvas = document.createElement('canvas');
        canvas.width = Math.round(group.ratio >= 1 ? 2400 : 2400 * group.ratio);
        canvas.height = Math.round(group.ratio >= 1 ? 2400 / group.ratio : 2400);
        var context = canvas.getContext('2d');
        var layers = group.layers.slice().sort(function (a, b) { return a.z - b.z; });
        return Promise.all(layers.map(function (layer) { return layer.type === 'image' ? productionImage(layer.url) : null; })).then(function (images) {
          layers.forEach(function (layer, index) {
            var x = layer.x * canvas.width / 100, y = layer.y * canvas.height / 100;
            var width = layer.width * canvas.width / 100, height = layer.height * canvas.height / 100;
            if (layer.type === 'image') {
              var image = images[index];
              if (group.fit === 'contain') {
                var scale = Math.min(width / image.naturalWidth, height / image.naturalHeight);
                var drawWidth = image.naturalWidth * scale, drawHeight = image.naturalHeight * scale;
                context.drawImage(image, x + (width - drawWidth) / 2, y + (height - drawHeight) / 2, drawWidth, drawHeight);
              } else context.drawImage(image, x, y, width, height);
            }
            else {
              var size = Math.min(width * .18, height * .68), lines = [], line = '';
              context.save(); context.beginPath(); context.rect(x, y, width, height); context.clip();
              context.font = size + 'px ' + group.font;
              Array.from(group.text.trim().replace(/\s+/g, ' ')).forEach(function (character) {
                if (line && context.measureText(line + character).width > width * .96) { lines.push(line); line = ''; }
                line += character;
              });
              if (line) lines.push(line);
              context.fillStyle = group.color; context.textAlign = 'center'; context.textBaseline = 'middle';
              lines.forEach(function (value, i) { context.fillText(value, x + width / 2, y + height / 2 + (i - (lines.length - 1) / 2) * size * 1.05); });
              context.restore();
            }
          });
          return productionPNG(canvas, 'creativemoro-' + group.name.toLowerCase().replace(/ /g, '-') + '.png').then(function (file) { return { name: group.name, file: file }; });
        });
      }));
    }).then(function (results) {
      return Promise.all(Array.prototype.map.call(form.querySelectorAll('[data-dual-slot], [data-artwork-slot]'), function (slot) {
        var file = slot.files && slot.files[0];
        if (!file || !(/image\/webp/i.test(file.type) || /\.webp$/i.test(file.name))) return;
        var url = URL.createObjectURL(file);
        return productionImage(url).then(function (image) {
          var canvas = document.createElement('canvas'); canvas.width = image.naturalWidth; canvas.height = image.naturalHeight;
          canvas.getContext('2d').drawImage(image, 0, 0);
          return productionPNG(canvas, file.name.replace(/\.[^.]+$/, '') + '.png');
        }).then(function (png) {
          var transfer = new DataTransfer(); transfer.items.add(png); slot.files = transfer.files;
        }).finally(function () { URL.revokeObjectURL(url); });
      })).then(function () {
        results.forEach(function (result) { setProductionFile(form, result.name, result.file); });
        return productionZIP(results.map(function (result) { return result.file; })).then(function (zip) {
          if (zip.size > 19000000) throw new Error('Print archive is too large.');
          setProductionFile(form, 'Print files ZIP', zip);
        });
      });
    });
  }


  document.addEventListener('DOMContentLoaded', function () {
    initMobileNavigation();
    initMegaNavigation();
    initLocalizationSelectors();
    initHorizontalScrollers();
    initTabbedProductShowcases();
    initProductGalleries();
    initVariantPickers();
    initQuickAdd();
    initCustomDesigners();
    initDualCustomDesigners();
    initCustomerCarousels();
    initDeliveryEstimates();
    initCartImageZoom();
    initAjaxCart();
  });

  function initDeliveryEstimates() {
    function addBusinessDays(date, days) {
      var result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      var remaining = Math.max(0, Number(days) || 0);
      while (remaining > 0) {
        result.setDate(result.getDate() + 1);
        var weekday = result.getDay();
        if (weekday !== 0 && weekday !== 6) remaining -= 1;
      }
      return result;
    }

    function formatRange(start, end) {
      var monthDay = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
      if (start.getMonth() === end.getMonth()) {
        var month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(start);
        return month + ' ' + start.getDate() + '\u2013' + end.getDate();
      }
      return monthDay.format(start) + '\u2013' + monthDay.format(end);
    }

    document.querySelectorAll('[data-delivery-estimate]').forEach(function (card) {
      var minimum = Number(card.dataset.minimumDays) || 7;
      var maximum = Math.max(minimum, Number(card.dataset.maximumDays) || 9);
      var output = card.querySelector('[data-delivery-date]');
      if (!output) return;
      var today = new Date();
      output.textContent = formatRange(addBusinessDays(today, minimum), addBusinessDays(today, maximum));
    });
  }

  function initMobileNavigation() {
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;

    function closeMenu() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
      document.body.classList.remove('mobile-navigation-open');
    }

    toggle.addEventListener('click', function () {
      var open = !menu.classList.contains('is-open');
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', String(!open));
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      document.body.classList.toggle('mobile-navigation-open', open);
    });
    menu.addEventListener('click', function (event) {
      if (event.target.closest('a') || event.target.closest('[data-mobile-menu-close]')) closeMenu();
    });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeMenu(); });
    window.addEventListener('resize', function () { if (window.innerWidth >= 990) closeMenu(); }, { passive: true });
  }

  function initMegaNavigation() {
    var navigation = document.querySelector('[data-mega-navigation]');
    if (!navigation) return;
    var items = Array.prototype.slice.call(navigation.querySelectorAll('[data-mega-item]'));
    var closeTimer = 0;

    function closeItem(item) {
      if (!item) return;
      item.classList.remove('is-open');
      var toggle = item.querySelector('[data-mega-toggle]');
      var menu = item.querySelector('[data-mega-menu]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (menu) menu.setAttribute('aria-hidden', 'true');
    }

    function closeAll(except) {
      items.forEach(function (item) { if (item !== except) closeItem(item); });
    }

    function openItem(item) {
      window.clearTimeout(closeTimer);
      closeAll(item);
      item.classList.add('is-open');
      var toggle = item.querySelector('[data-mega-toggle]');
      var menu = item.querySelector('[data-mega-menu]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (menu) menu.setAttribute('aria-hidden', 'false');
    }

    items.forEach(function (item) {
      var toggle = item.querySelector('[data-mega-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (item.classList.contains('is-open')) closeItem(item); else openItem(item);
        });
      }

      item.addEventListener('pointerenter', function (event) {
        if (event.pointerType !== 'touch' && window.innerWidth >= 990) openItem(item);
      });
      item.addEventListener('pointerleave', function (event) {
        if (event.pointerType === 'touch') return;
        closeTimer = window.setTimeout(function () { closeItem(item); }, 140);
      });
      item.addEventListener('focusin', function () { openItem(item); });
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) closeItem(item);
      });

      item.querySelectorAll('[data-mega-group]').forEach(function (groupButton) {
        function selectGroup() {
          var groupId = groupButton.dataset.megaGroup;
          item.querySelectorAll('[data-mega-group]').forEach(function (button) {
            var active = button === groupButton;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-selected', String(active));
          });
          item.querySelectorAll('[data-mega-panel]').forEach(function (panel) {
            panel.classList.toggle('is-active', panel.dataset.megaPanel === groupId);
          });
        }
        groupButton.addEventListener('mouseenter', selectGroup);
        groupButton.addEventListener('focus', selectGroup);
        groupButton.addEventListener('click', selectGroup);
      });
    });

    document.addEventListener('click', function (event) {
      if (!navigation.contains(event.target)) closeAll();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll();
    });
  }

  function initLocalizationSelectors() {
    document.querySelectorAll('[data-localization-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        if (select.form) select.form.submit();
      });
    });
  }

  function initHorizontalScrollers() {
    document.querySelectorAll('[data-horizontal-scroller]').forEach(function (scroller) {
      var track = scroller.querySelector('[data-scroll-track]');
      var previous = scroller.querySelector('[data-scroll-previous]');
      var next = scroller.querySelector('[data-scroll-next]');
      if (!track) return;
      function move(direction) {
        track.scrollBy({ left: direction * Math.max(240, track.clientWidth * .78), behavior: 'smooth' });
      }
      if (previous) previous.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });
    });
  }

  function initTabbedProductShowcases() {
    document.querySelectorAll('[data-tabbed-products]').forEach(function (section) {
      var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-tab-button]'));
      var panels = Array.prototype.slice.call(section.querySelectorAll('[data-tab-panel]'));
      var track = section.querySelector('[data-tabs-track]');
      if (!buttons.length) return;

      function selectTab(button) {
        var tabId = button.dataset.tabButton;
        buttons.forEach(function (item) {
          var active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
        });
        panels.forEach(function (panel) {
          var active = panel.dataset.tabPanel === tabId;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
        button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      buttons.forEach(function (button) { button.addEventListener('click', function () { selectTab(button); }); });
      var previous = section.querySelector('[data-tabs-previous]');
      var next = section.querySelector('[data-tabs-next]');
      if (previous && track) previous.addEventListener('click', function () { track.scrollBy({ left: -Math.max(220, track.clientWidth * .65), behavior: 'smooth' }); });
      if (next && track) next.addEventListener('click', function () { track.scrollBy({ left: Math.max(220, track.clientWidth * .65), behavior: 'smooth' }); });
    });
  }

  function initCustomerCarousels() {
    document.querySelectorAll('[data-customer-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-carousel-slide]'));
      var previous = carousel.querySelector('[data-carousel-previous]');
      var next = carousel.querySelector('[data-carousel-next]');
      var progress = carousel.querySelector('[data-carousel-progress]');
      var autoplay = carousel.dataset.autoplay === 'true';
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null;
      var scrollFrame = 0;
      if (!track || slides.length < 2) return;

      function activeIndex() {
        var trackLeft = track.getBoundingClientRect().left;
        var nearest = 0;
        var nearestDistance = Infinity;
        slides.forEach(function (slide, index) {
          var distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
          if (distance < nearestDistance) {
            nearest = index;
            nearestDistance = distance;
          }
        });
        return nearest;
      }

      function updateProgress() {
        if (!progress) return;
        var index = activeIndex();
        progress.style.width = 100 / slides.length + '%';
        progress.style.transform = 'translateX(' + (index * 100) + '%)';
      }

      function goTo(index) {
        var normalized = (index + slides.length) % slides.length;
        track.scrollTo({ left: slides[normalized].offsetLeft - track.offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
      }

      function restartAutoplay() {
        window.clearInterval(timer);
        timer = null;
        if (!autoplay || reducedMotion || document.hidden) return;
        timer = window.setInterval(function () { goTo(activeIndex() + 1); }, 4800);
      }

      if (previous) previous.addEventListener('click', function () { goTo(activeIndex() - 1); restartAutoplay(); });
      if (next) next.addEventListener('click', function () { goTo(activeIndex() + 1); restartAutoplay(); });
      track.addEventListener('scroll', function () {
        if (scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(function () {
          scrollFrame = 0;
          updateProgress();
        });
      }, { passive: true });
      carousel.addEventListener('mouseenter', function () { window.clearInterval(timer); });
      carousel.addEventListener('mouseleave', restartAutoplay);
      carousel.addEventListener('focusin', function () { window.clearInterval(timer); });
      carousel.addEventListener('focusout', restartAutoplay);
      document.addEventListener('visibilitychange', restartAutoplay);
      window.addEventListener('resize', updateProgress, { passive: true });

      updateProgress();
      restartAutoplay();
    });
  }

  function initProductGalleries() {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      var mainImage = gallery.querySelector('[data-gallery-main]');
      if (!mainImage) return;

      gallery.addEventListener('click', function (event) {
        var thumbnail = event.target.closest('[data-gallery-thumb]');
        if (!thumbnail) return;

        mainImage.src = thumbnail.dataset.gallerySrc;
        mainImage.alt = thumbnail.dataset.galleryAlt || mainImage.alt;
        if (thumbnail.dataset.galleryMediaId) mainImage.dataset.galleryMediaId = thumbnail.dataset.galleryMediaId;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (item) {
          item.classList.toggle('is-active', item === thumbnail);
        });
      });
    });
  }

  function initVariantPickers() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var jsonNode = picker.querySelector('[data-variant-json]');
      var imageJsonNode = picker.querySelector('[data-variant-image-json]');
      var variantInput = picker.querySelector('[data-variant-id]');
      var section = picker.closest('[data-product-section]');
      var groups = Array.prototype.slice.call(picker.querySelectorAll('[data-option-group]'));
      if (!jsonNode || !variantInput || !section || !groups.length) return;

      var variants;
      try {
        variants = JSON.parse(jsonNode.textContent);
      } catch (error) {
        return;
      }

      var optimizedVariantImages = {};
      if (imageJsonNode) {
        try {
          JSON.parse(imageJsonNode.textContent).forEach(function (item) {
            if (item && item.id) optimizedVariantImages[String(item.id)] = item;
          });
        } catch (error) {}
      }
      var preloadedImages = {};

      function preloadVariantImage(imageData) {
        if (!imageData || !imageData.src || preloadedImages[imageData.src]) return;
        preloadedImages[imageData.src] = true;
        var preloader = new Image();
        preloader.decoding = 'async';
        try { preloader.fetchPriority = 'low'; } catch (error) {}
        preloader.src = imageData.src;
      }

      function selectedOptions() {
        return groups.map(function (group) {
          var checked = group.querySelector('.option-input:checked');
          return checked ? checked.value : '';
        });
      }

      function findExactVariant(values) {
        return variants.find(function (variant) {
          return variant.options.every(function (value, index) {
            return value === values[index];
          });
        });
      }

      function selectVariantOptions(variant) {
        groups.forEach(function (group, index) {
          var inputs = group.querySelectorAll('.option-input');
          inputs.forEach(function (input) {
            input.checked = input.value === variant.options[index];
          });
        });
      }

      function imageForVariant(variant) {
        var optimizedImage = variant ? optimizedVariantImages[String(variant.id)] : null;
        if (optimizedImage && optimizedImage.src) return optimizedImage;
        if (variant && variant.featured_image && variant.featured_image.src) {
          return {
            src: variant.featured_image.src,
            alt: variant.featured_image.alt,
            media_id: variant.featured_media ? variant.featured_media.id : null
          };
        }

        var colorIndex = groups.findIndex(function (group) {
          return group.hasAttribute('data-color-option');
        });
        if (colorIndex < 0 || !variant) return null;

        var sameColorVariant = variants.find(function (candidate) {
          return candidate.options[colorIndex] === variant.options[colorIndex] &&
            candidate.featured_image && candidate.featured_image.src;
        });
        if (!sameColorVariant) return null;
        return optimizedVariantImages[String(sameColorVariant.id)] || sameColorVariant.featured_image;
      }

      function renderVariant(variant) {
        if (!variant) return;
        variantInput.value = variant.id;

        groups.forEach(function (group) {
          var selected = group.querySelector('.option-input:checked');
          var label = group.querySelector('[data-selected-value]');
          if (selected && label) label.textContent = selected.value;
        });

        section.querySelectorAll('[data-variant-price]').forEach(function (node) {
          node.textContent = formatMoney(variant.price, picker.dataset.currency || 'USD');
        });

        section.querySelectorAll('[data-add-to-cart]').forEach(function (button) {
          if (!button.dataset.availableText) button.dataset.availableText = button.textContent.trim();
          button.disabled = !variant.available;
          button.textContent = variant.available ? button.dataset.availableText : 'Sold out';
        });

        var variantImage = imageForVariant(variant);
        if (variantImage) {
          section.querySelectorAll('[data-gallery-main], [data-variant-image]').forEach(function (image) {
            if (image.src === variantImage.src || image.getAttribute('src') === variantImage.src) return;
            image.classList.add('is-switching');
            image.removeAttribute('srcset');
            image.removeAttribute('sizes');
            image.src = variantImage.src;
            if (variantImage.alt) image.alt = variantImage.alt;
            if (variantImage.media_id) image.dataset.galleryMediaId = variantImage.media_id;
            if (image.decode) {
              image.decode().catch(function () {}).then(function () { image.classList.remove('is-switching'); });
            } else {
              image.addEventListener('load', function () { image.classList.remove('is-switching'); }, { once: true });
            }
          });
          section.querySelectorAll('[data-gallery-thumb]').forEach(function (thumbnail) {
            thumbnail.classList.toggle('is-active', String(thumbnail.dataset.galleryMediaId) === String(variantImage.media_id));
          });
        }

        if (picker.dataset.updateUrl === 'true' && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      picker.addEventListener('change', function (event) {
        if (!event.target.classList.contains('option-input')) return;

        var values = selectedOptions();
        var variant = findExactVariant(values);

        if (!variant) {
          var changedGroup = event.target.closest('[data-option-group]');
          var changedIndex = groups.indexOf(changedGroup);
          variant = variants.find(function (candidate) {
            return candidate.available && candidate.options[changedIndex] === event.target.value;
          }) || variants.find(function (candidate) {
            return candidate.options[changedIndex] === event.target.value;
          });
          if (variant) selectVariantOptions(variant);
        }

        renderVariant(variant);
      });

      function preloadFromOption(event) {
        var input = event.target.closest('label') ? document.getElementById(event.target.closest('label').htmlFor) : event.target.closest('.option-input');
        if (!input || !input.classList.contains('option-input')) return;
        var group = input.closest('[data-option-group]');
        var changedIndex = groups.indexOf(group);
        var values = selectedOptions();
        values[changedIndex] = input.value;
        var variant = findExactVariant(values) || variants.find(function (candidate) {
          return candidate.available && candidate.options[changedIndex] === input.value;
        });
        preloadVariantImage(imageForVariant(variant));
      }
      picker.addEventListener('pointerover', preloadFromOption);
      picker.addEventListener('focusin', preloadFromOption);

      var initialVariant = variants.find(function (variant) {
        return String(variant.id) === String(variantInput.value);
      }) || findExactVariant(selectedOptions()) || variants[0];
      renderVariant(initialVariant);

      var preloadSoon = function () {
        var seen = {};
        variants.forEach(function (variant) {
          var imageData = imageForVariant(variant);
          if (!imageData || !imageData.src || seen[imageData.src] || Object.keys(seen).length >= 10) return;
          seen[imageData.src] = true;
          preloadVariantImage(imageData);
        });
      };
      if ('requestIdleCallback' in window) window.requestIdleCallback(preloadSoon, { timeout: 1200 });
      else window.setTimeout(preloadSoon, 250);
    });
  }

  function initQuickAdd() {
    var modal = document.querySelector('[data-quick-add-modal]');
    if (!modal) return;
    var panel = modal.querySelector('.quick-add-panel');
    var loading = modal.querySelector('[data-quick-add-loading]');
    var content = modal.querySelector('[data-quick-add-content]');
    var errorBox = modal.querySelector('[data-quick-add-error]');
    var title = modal.querySelector('[data-quick-add-title]');
    var price = modal.querySelector('[data-quick-add-price]');
    var image = modal.querySelector('[data-quick-add-image]');
    var optionsContainer = modal.querySelector('[data-quick-add-options]');
    var form = modal.querySelector('[data-quick-add-form]');
    var variantInput = modal.querySelector('[data-quick-add-variant-id]');
    var productLink = modal.querySelector('[data-quick-add-product-link]');
    var submitButton = modal.querySelector('[data-add-to-cart]');
    var currency = modal.dataset.currency || 'USD';
    var productCache = {};
    var activeTrigger = null;

    function openModal(trigger) {
      activeTrigger = trigger;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('quick-add-open');
      window.requestAnimationFrame(function () { modal.classList.add('is-open'); });
      if (loading) loading.hidden = false;
      if (content) content.hidden = true;
      if (errorBox) errorBox.hidden = true;
      if (title) title.textContent = trigger.dataset.productTitle || 'Product';
      window.setTimeout(function () { if (panel) panel.focus(); }, 30);
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('quick-add-open');
      window.setTimeout(function () { modal.hidden = true; }, 180);
      if (activeTrigger && document.contains(activeTrigger)) activeTrigger.focus();
      activeTrigger = null;
    }

    function loadProduct(trigger) {
      var url = trigger.dataset.productJsonUrl;
      if (!url) return Promise.reject(new Error('Product options are unavailable.'));
      if (!productCache[url]) {
        productCache[url] = fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (response) {
          if (!response.ok) throw new Error('Unable to load product options.');
          return response.json();
        }).catch(function (error) {
          delete productCache[url];
          throw error;
        });
      }
      return productCache[url];
    }

    function variantOptions(variant) {
      if (Array.isArray(variant.options)) return variant.options;
      return [variant.option1, variant.option2, variant.option3].filter(function (value) { return value != null; });
    }

    function optimizedImageUrl(source, width) {
      if (!source) return '';
      try {
        var url = new URL(source, window.location.origin);
        url.searchParams.set('width', String(width));
        return url.toString();
      } catch (error) {
        return source;
      }
    }

    function renderProduct(product, trigger) {
      if (trigger !== activeTrigger) return;
      var variants = product.variants || [];
      if (!variants.length) throw new Error('No variants are available for this product.');
      title.textContent = product.title || trigger.dataset.productTitle || 'Product';
      productLink.href = trigger.dataset.productUrl || product.url || '#';
      optionsContainer.textContent = '';

      var optionDefinitions = product.options || [];
      optionDefinitions.forEach(function (option, optionIndex) {
        var optionName = typeof option === 'string' ? option : (option.name || ('Option ' + (optionIndex + 1)));
        var values = typeof option === 'object' && Array.isArray(option.values) ? option.values.slice() : [];
        if (!values.length) {
          variants.forEach(function (variant) {
            var value = variantOptions(variant)[optionIndex];
            if (value != null && values.indexOf(value) < 0) values.push(value);
          });
        }
        if (optionDefinitions.length === 1 && values.length === 1 && values[0] === 'Default Title') return;

        var label = document.createElement('label');
        label.className = 'quick-add-option';
        var labelText = document.createElement('span');
        labelText.textContent = optionName;
        var selectWrap = document.createElement('span');
        selectWrap.className = 'quick-add-select-wrap';
        var select = document.createElement('select');
        select.dataset.quickAddOption = String(optionIndex);
        select.setAttribute('aria-label', optionName);
        values.forEach(function (value) {
          var optionNode = document.createElement('option');
          optionNode.value = value;
          optionNode.textContent = value;
          select.appendChild(optionNode);
        });
        var chevron = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        chevron.setAttribute('viewBox', '0 0 16 16');
        chevron.setAttribute('aria-hidden', 'true');
        var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'm4 6 4 4 4-4');
        chevron.appendChild(path);
        selectWrap.appendChild(select);
        selectWrap.appendChild(chevron);
        label.appendChild(labelText);
        label.appendChild(selectWrap);
        optionsContainer.appendChild(label);
      });

      function updateVariant() {
        var selectedValues = [];
        optionsContainer.querySelectorAll('[data-quick-add-option]').forEach(function (select) {
          selectedValues[Number(select.dataset.quickAddOption)] = select.value;
        });
        var selectedVariant = selectedValues.length ? variants.find(function (variant) {
          var values = variantOptions(variant);
          return selectedValues.every(function (value, index) { return value == null || values[index] === value; });
        }) : null;
        selectedVariant = selectedVariant || variants.find(function (variant) { return variant.available; }) || variants[0];

        variantInput.value = selectedVariant.id;
        price.textContent = formatMoney(selectedVariant.price, currency);
        submitButton.disabled = !selectedVariant.available;
        submitButton.textContent = selectedVariant.available ? 'Add to cart' : 'Sold out';

        var featured = selectedVariant.featured_image;
        var fallbackImage = product.featured_image || (product.images && product.images[0]);
        if (fallbackImage && fallbackImage.src) fallbackImage = fallbackImage.src;
        var imageSource = featured && featured.src ? featured.src : fallbackImage;
        if (imageSource) {
          image.src = optimizedImageUrl(imageSource, 600);
          image.alt = product.title || 'Product image';
          image.hidden = false;
        } else {
          image.hidden = true;
        }
      }

      optionsContainer.onchange = updateVariant;
      var firstAvailable = variants.find(function (variant) { return variant.available; }) || variants[0];
      var firstValues = variantOptions(firstAvailable);
      optionsContainer.querySelectorAll('[data-quick-add-option]').forEach(function (select) {
        var value = firstValues[Number(select.dataset.quickAddOption)];
        if (value != null) select.value = value;
      });
      var quantity = form.querySelector('[name="quantity"]');
      if (quantity) quantity.value = 1;
      updateVariant();
      loading.hidden = true;
      content.hidden = false;
    }

    function showError(error) {
      if (loading) loading.hidden = true;
      if (content) content.hidden = true;
      if (errorBox) {
        errorBox.textContent = error && error.message ? error.message : 'Unable to load this product.';
        errorBox.hidden = false;
      }
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-quick-add]');
      if (trigger) {
        event.preventDefault();
        openModal(trigger);
        loadProduct(trigger).then(function (product) { renderProduct(product, trigger); }).catch(showError);
        return;
      }
      if (event.target.closest('[data-quick-add-close]')) {
        event.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('pointerover', function (event) {
      var trigger = event.target.closest('[data-quick-add]');
      if (trigger) loadProduct(trigger).catch(function () {});
    });
    document.addEventListener('focusin', function (event) {
      var trigger = event.target.closest('[data-quick-add]');
      if (trigger) loadProduct(trigger).catch(function () {});
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
    document.addEventListener('cart:item-added', function () {
      if (!modal.hidden) closeModal();
    });
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency
      }).format(Number(cents) / 100);
    } catch (error) {
      return '$' + (Number(cents) / 100).toFixed(2);
    }
  }

  function initDualCustomDesigners() {
    document.querySelectorAll('[data-dual-designer]').forEach(function (root) {
      var form = root.querySelector('form');
      var previewFile = root.querySelector('[data-dual-preview-file]');
      var errorBox = root.querySelector('[data-dual-error]');
      var finishedPreview = root.querySelector('[data-dual-finished-preview]');
      var finishedToggle = root.querySelector('[data-dual-finished-toggle]');
      var finishedCloseButtons = Array.prototype.slice.call(root.querySelectorAll('[data-dual-finished-close]'));
      var finishedEmpty = root.querySelector('[data-dual-finished-empty]');
      var inlinePreviewStage = root.querySelector('[data-dual-preview-stage]');
      var inlinePreviewEmpty = root.querySelector('[data-dual-inline-empty]');
      var sideTabs = Array.prototype.slice.call(root.querySelectorAll('[data-dual-side-tab]'));
      var editorSideLabel = root.querySelector('[data-dual-editor-side-label]');
      var studioLayout = root.querySelector('[data-dual-studio-layout]');
      var toolsColumn = root.querySelector('[data-dual-tools-column]');
      var studioMain = root.querySelector('[data-dual-studio-main]');
      var buyCard = root.querySelector('[data-dual-buy-card]');
      var productAnchor = root.querySelector('[data-dual-product-anchor]');
      var mobileStudio = window.matchMedia('(max-width: 720px)');
      var mobileToolbar = root.querySelector('[data-mobile-editor-toolbar]');
      var mobileToolbarButtons = mobileToolbar ? Array.prototype.slice.call(mobileToolbar.querySelectorAll('[data-mobile-editor-target]')) : [];
      var previouslyFocused = null;
      var preparing = false;
      var sequence = 0;
      var responsiveRenderFrame = 0;
      if (!form || !previewFile) return;

      function setDualMobilePanel(panel, shouldScroll) {
        if (panel === 'preview') {
          if (finishedToggle) finishedToggle.click();
          else if (inlinePreviewStage) inlinePreviewStage.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        root.dataset.mobileActivePanel = panel;
        mobileToolbarButtons.forEach(function (button) {
          var active = button.dataset.mobileEditorTarget === panel;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (shouldScroll && mobileStudio.matches && toolsColumn) {
          window.requestAnimationFrame(function () { toolsColumn.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); });
        }
      }

      mobileToolbarButtons.forEach(function (button) {
        button.addEventListener('click', function () { setDualMobilePanel(button.dataset.mobileEditorTarget, true); });
      });
      setDualMobilePanel(root.dataset.mobileActivePanel || 'position', false);

      function syncResponsiveStudioOrder() {
        if (!studioLayout || !toolsColumn || !studioMain || !buyCard || !productAnchor) return;
        if (mobileStudio.matches) {
          studioLayout.insertBefore(buyCard, studioLayout.firstElementChild);
          buyCard.insertBefore(studioMain, productAnchor.nextSibling);
          buyCard.insertBefore(toolsColumn, studioMain.nextSibling);
        } else {
          studioLayout.insertBefore(toolsColumn, studioLayout.firstElementChild);
          studioLayout.insertBefore(studioMain, buyCard);
          studioLayout.appendChild(buyCard);
        }
      }
      syncResponsiveStudioOrder();
      if (mobileStudio.addEventListener) mobileStudio.addEventListener('change', syncResponsiveStudioOrder);
      else if (mobileStudio.addListener) mobileStudio.addListener(syncResponsiveStudioOrder);

      var states = ['front', 'back'].map(function (side) {
        var state = {
          side: side,
          zone: root.querySelector('[data-dual-zone][data-side="' + side + '"]'),
          canvas: root.querySelector('[data-dual-canvas]'),
          picker: root.querySelector('[data-dual-picker][data-side="' + side + '"]'),
          slots: Array.prototype.slice.call(root.querySelectorAll('[data-dual-slot][data-side="' + side + '"]')),
          list: root.querySelector('[data-dual-list][data-side="' + side + '"]'),
          empty: root.querySelector('[data-dual-zone][data-side="' + side + '"] [data-dual-empty]'),
          textInput: root.querySelector('[data-dual-text][data-side="' + side + '"]'),
          fontInput: root.querySelector('[data-dual-font][data-side="' + side + '"]'),
          colorInput: root.querySelector('[data-dual-color][data-side="' + side + '"]'),
          layoutInput: root.querySelector('[data-dual-layout][data-side="' + side + '"]'),
          layers: [],
          selected: null,
          textLayer: null
        };
        return state;
      });
      if (states.some(function (state) { return !state.zone || !state.canvas || !state.picker || !state.list || !state.textInput || !state.fontInput || !state.colorInput || !state.layoutInput; })) return;

      function setActiveSide(side) {
        root.dataset.mobileActiveSide = side;
        states.forEach(function (state) {
          state.zone.classList.toggle('is-active-side', state.side === side);
          state.zone.setAttribute('aria-hidden', state.side === side ? 'false' : 'true');
        });
        sideTabs.forEach(function (button) {
          var active = button.dataset.dualSideTab === side;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
          button.innerHTML = '<span></span>' + (button.dataset.dualSideTab === 'front' ? 'Front' : 'Back') + (active ? ' &middot; Editing' : ' &middot; Ready');
        });
        if (editorSideLabel) editorSideLabel.textContent = (side === 'front' ? 'Front' : 'Back') + ' print area';
      }

      sideTabs.forEach(function (button) {
        button.addEventListener('click', function () { setActiveSide(button.dataset.dualSideTab); });
      });
      setActiveSide('front');

      window.addEventListener('resize', function () {
        if (responsiveRenderFrame) return;
        responsiveRenderFrame = window.requestAnimationFrame(function () {
          responsiveRenderFrame = 0;
          states.forEach(function (state) {
            state.layers.forEach(function (layer) { applyLayer(state, layer); });
          });
          renderDualFinishedPreview();
        });
      });

      states.forEach(function (state) {
        state.picker.addEventListener('change', function () {
          setActiveSide(state.side);
          addFiles(state, Array.prototype.slice.call(state.picker.files || []));
          state.picker.value = '';
        });
        state.textInput.addEventListener('input', function () { syncText(state); });
        state.textInput.addEventListener('focus', function () { setActiveSide(state.side); });
        state.fontInput.addEventListener('change', function () { syncText(state); });
        state.fontInput.addEventListener('focus', function () { setActiveSide(state.side); });
        state.colorInput.addEventListener('input', function () { syncText(state); });
        state.colorInput.addEventListener('focus', function () { setActiveSide(state.side); });
        root.querySelectorAll('[data-dual-position][data-side="' + state.side + '"]').forEach(function (button) {
          button.addEventListener('click', function () {
            if (state.selected) positionDualLayer(state, state.selected, button.dataset.position);
          });
        });
        var arrangeControl = root.querySelector('[data-dual-arrange][data-side="' + state.side + '"]');
        var forwardControl = root.querySelector('[data-dual-front][data-side="' + state.side + '"]');
        var deleteControl = root.querySelector('[data-dual-delete][data-side="' + state.side + '"]');
        if (arrangeControl) arrangeControl.addEventListener('click', function () { arrangeDualLayers(state); });
        if (forwardControl) forwardControl.addEventListener('click', function () {
          if (!state.selected) return;
          state.selected.z = ++sequence;
          state.selected.element.style.zIndex = state.selected.z;
          updateState(state);
        });
        if (deleteControl) deleteControl.addEventListener('click', function () {
          if (state.selected) removeLayer(state, state.selected);
        });
      });

      if (finishedToggle && finishedPreview) {
        finishedToggle.addEventListener('click', function () { setDualFinishedPreviewVisibility(finishedPreview.hidden); });
      }
      finishedCloseButtons.forEach(function (button) {
        button.addEventListener('click', function () { setDualFinishedPreviewVisibility(false); });
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && finishedPreview && !finishedPreview.hidden) setDualFinishedPreviewVisibility(false);
      });

      root.querySelector('[data-dual-reset]').addEventListener('click', function () {
        states.forEach(function (state) {
          state.layers.forEach(function (layer) {
            layer.x = 15;
            layer.y = 15;
            layer.width = 70;
            layer.height = layer.type === 'text' ? 24 : preferredHeight(state, layer, 70);
            clampLayer(layer);
            applyLayer(state, layer);
          });
          updateState(state);
        });
      });

      root.addEventListener('change', function (event) {
        if (event.target.classList.contains('option-input')) invalidatePreview();
      });

      form.addEventListener('submit', function (event) {
        states.forEach(updateState);
        if (!states.some(function (state) { return state.layers.length; })) {
          event.preventDefault();
          showError('Upload artwork or add text to the front or back before adding this product to the cart.');
          states[0].picker.focus();
          return;
        }
        if (form.dataset.dualPreviewReady === 'true' && previewFile.files && previewFile.files.length) return;

        event.preventDefault();
        if (preparing) return;
        preparing = true;
        showError('');
        var submit = event.submitter || form.querySelector('[data-add-to-cart]');
        var originalText = submit ? submit.textContent : '';
        if (submit) {
          submit.disabled = true;
          submit.classList.add('is-loading');
          submit.textContent = 'Preparing both sides...';
        }

        var groups = states.map(function (state) {
          return { name: state.side === 'front' ? 'Front print PNG' : 'Back print PNG', layers: state.layers,
            zone: root.querySelector('[data-dual-inline-zone][data-side="' + state.side + '"]') || state.zone,
            text: state.textInput.value, color: state.colorInput.value, font: dualFontStack(state.fontInput.value) };
        });
        var signature = productionSignature(form, groups);
        Promise.all([createCombinedPreview(states), Promise.resolve().then(function () { return prepareProductionFiles(form, groups); })]).then(function (results) {
          if (signature !== productionSignature(form, groups)) throw new Error('Design changed during export. Please try again.');
          var file = results[0];
          var transfer = new DataTransfer();
          transfer.items.add(file);
          previewFile.files = transfer.files;
          form.dataset.dualPreviewReady = 'true';
          preparing = false;
          if (submit) {
            submit.disabled = false;
            submit.classList.remove('is-loading');
            submit.textContent = originalText;
          }
          form.requestSubmit(submit || undefined);
        }).catch(function () {
          preparing = false;
          invalidatePreview();
          showError('We could not prepare the front-and-back preview. Please check your images and try again.');
          if (submit) {
            submit.disabled = false;
            submit.classList.remove('is-loading');
            submit.textContent = originalText;
          }
        });
      });

      function addFiles(state, files) {
        files.filter(function (file) { return file && /^image\/(png|jpe?g|webp)$/i.test(file.type); }).forEach(function (file) {
          var slot = state.slots.find(function (candidate) { return !candidate.dataset.layerId; });
          if (!slot) {
            showError('Each side accepts up to three artwork files.');
            return;
          }
          try {
            var transfer = new DataTransfer();
            transfer.items.add(file);
            slot.files = transfer.files;
          } catch (error) { return; }

          var layer = createImageLayer(state, file, slot);
          state.layers.push(layer);
          slot.dataset.layerId = layer.id;
          state.zone.appendChild(layer.element);
          selectLayer(state, layer);
          layer.image.addEventListener('load', function () {
            if (state.layers.length === 1) {
              layer.width = 72;
              layer.height = 84;
              layer.x = 14;
              layer.y = 8;
            } else {
              layer.height = preferredHeight(state, layer, layer.width);
            }
            clampLayer(layer);
            applyLayer(state, layer);
            updateState(state);
          });
        });
        renderList(state);
        refreshState(state);
        updateState(state);
      }

      function createImageLayer(state, file, slot) {
        var layer = baseLayer(state, 'image');
        var image = document.createElement('img');
        layer.file = file;
        layer.slot = slot;
        layer.url = URL.createObjectURL(file);
        layer.image = image;
        image.src = layer.url;
        image.alt = '';
        image.draggable = false;
        layer.element.appendChild(image);
        createHandles(state, layer);
        return layer;
      }

      function createTextLayer(state) {
        var layer = baseLayer(state, 'text');
        var span = document.createElement('span');
        layer.element.classList.add('artwork-text-layer');
        layer.element.appendChild(span);
        layer.textNode = span;
        layer.height = 24;
        createHandles(state, layer);
        return layer;
      }

      function baseLayer(state, type) {
        var element = document.createElement('div');
        var layer = { id: state.side + '-' + (++sequence), type: type, element: element, x: 15, y: 15, width: 70, height: 70, z: sequence + 10 };
        element.className = 'artwork-layer';
        element.tabIndex = 0;
        element.dataset.layerId = layer.id;
        element.setAttribute('aria-label', 'Move ' + state.side + ' ' + type);
        element.style.zIndex = layer.z;
        element.addEventListener('pointerdown', function (event) { if (!event.target.closest('.artwork-resize-handle')) startDrag(state, layer, event); });
        element.addEventListener('focus', function () { selectLayer(state, layer); });
        element.addEventListener('keydown', function (event) {
          var step = event.shiftKey ? 5 : 1;
          if (event.key === 'Delete' || event.key === 'Backspace') { event.preventDefault(); removeLayer(state, layer); return; }
          if (event.key === 'ArrowLeft') layer.x -= step;
          else if (event.key === 'ArrowRight') layer.x += step;
          else if (event.key === 'ArrowUp') layer.y -= step;
          else if (event.key === 'ArrowDown') layer.y += step;
          else return;
          event.preventDefault();
          clampLayer(layer);
          applyLayer(state, layer);
          updateState(state);
        });
        applyLayer(state, layer);
        return layer;
      }

      function createHandles(state, layer) {
        ['nw', 'n', 'ne', 'e', 'se', 's', 'sw', 'w'].forEach(function (direction) {
          var handle = document.createElement('span');
          handle.className = 'artwork-resize-handle artwork-resize-' + direction;
          handle.dataset.resizeDirection = direction;
          handle.setAttribute('aria-hidden', 'true');
          handle.addEventListener('pointerdown', function (event) { event.stopPropagation(); startResize(state, layer, direction, event); });
          layer.element.appendChild(handle);
        });
      }

      function startDrag(state, layer, event) {
        if (event.button !== undefined && event.button !== 0) return;
        event.preventDefault();
        selectLayer(state, layer);
        var rect = state.zone.getBoundingClientRect();
        var startX = event.clientX;
        var startY = event.clientY;
        var left = layer.x / 100 * rect.width;
        var top = layer.y / 100 * rect.height;

        function move(moveEvent) {
          var visibleEdge = 24;
          var width = layer.width / 100 * rect.width;
          var height = layer.height / 100 * rect.height;
          layer.x = clamp(left + moveEvent.clientX - startX, -width + visibleEdge, rect.width - visibleEdge) / rect.width * 100;
          layer.y = clamp(top + moveEvent.clientY - startY, -height + visibleEdge, rect.height - visibleEdge) / rect.height * 100;
          applyLayer(state, layer);
          updateState(state);
        }
        bindPointer(move);
      }

      function startResize(state, layer, direction, event) {
        if (event.button !== undefined && event.button !== 0) return;
        event.preventDefault();
        selectLayer(state, layer);
        var rect = state.zone.getBoundingClientRect();
        var startX = event.clientX;
        var startY = event.clientY;
        var left = layer.x / 100 * rect.width;
        var top = layer.y / 100 * rect.height;
        var width = layer.width / 100 * rect.width;
        var height = layer.height / 100 * rect.height;
        var right = left + width;
        var bottom = top + height;

        function move(moveEvent) {
          var dx = moveEvent.clientX - startX;
          var dy = moveEvent.clientY - startY;
          var nextLeft = left;
          var nextTop = top;
          var nextWidth = width;
          var nextHeight = height;
          if (direction.indexOf('e') >= 0) nextWidth = clamp(width + dx, 32, rect.width * 3);
          if (direction.indexOf('w') >= 0) { nextLeft = clamp(left + dx, -rect.width * 2, right - 32); nextWidth = right - nextLeft; }
          if (direction.indexOf('s') >= 0) nextHeight = clamp(height + dy, 28, rect.height * 3);
          if (direction.indexOf('n') >= 0) { nextTop = clamp(top + dy, -rect.height * 2, bottom - 28); nextHeight = bottom - nextTop; }
          layer.x = nextLeft / rect.width * 100;
          layer.y = nextTop / rect.height * 100;
          layer.width = nextWidth / rect.width * 100;
          layer.height = nextHeight / rect.height * 100;
          applyLayer(state, layer);
          updateState(state);
        }
        bindPointer(move);
      }

      function bindPointer(move) {
        function stop() {
          window.removeEventListener('pointermove', move);
          window.removeEventListener('pointerup', stop);
          window.removeEventListener('pointercancel', stop);
        }
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', stop);
        window.addEventListener('pointercancel', stop);
      }

      function syncText(state) {
        var value = state.textInput.value.trim();
        if (!value) {
          if (state.textLayer) removeLayer(state, state.textLayer);
          return;
        }
        if (!state.textLayer) {
          state.textLayer = createTextLayer(state);
          state.layers.push(state.textLayer);
          state.zone.appendChild(state.textLayer.element);
          selectLayer(state, state.textLayer);
        }
        invalidatePreview();
        state.textLayer.textNode.textContent = value;
        state.textLayer.textNode.style.color = state.colorInput.value;
        state.textLayer.textNode.style.fontFamily = dualFontStack(state.fontInput.value);
        applyLayer(state, state.textLayer);
        refreshState(state);
        renderList(state);
        updateState(state);
      }

      function dualFontStack(fontName) {
        if (fontName === 'Georgia' || fontName === 'Times New Roman') return '"' + fontName + '", serif';
        if (fontName === 'Courier New') return '"Courier New", monospace';
        if (fontName === 'Brush Script MT') return '"Brush Script MT", cursive';
        return '"' + fontName + '", Arial, sans-serif';
      }

      function preferredHeight(state, layer, widthPercent) {
        if (layer.image && layer.image.naturalWidth && layer.image.naturalHeight) {
          var ratio = state.zone.clientWidth / Math.max(1, state.zone.clientHeight);
          return widthPercent * ratio * layer.image.naturalHeight / layer.image.naturalWidth;
        }
        return 24;
      }

      function positionDualLayer(state, layer, position) {
        var inset = 4;
        var horizontal = position.indexOf('left') >= 0 ? 'left' : (position.indexOf('right') >= 0 ? 'right' : 'center');
        var vertical = position.indexOf('top') >= 0 ? 'top' : (position.indexOf('bottom') >= 0 ? 'bottom' : 'middle');
        layer.x = horizontal === 'left' ? inset : (horizontal === 'right' ? 100 - layer.width - inset : (100 - layer.width) / 2);
        layer.y = vertical === 'top' ? inset : (vertical === 'bottom' ? 100 - layer.height - inset : (100 - layer.height) / 2);
        clampLayer(layer);
        applyLayer(state, layer);
        updateState(state);
      }

      function arrangeDualLayers(state) {
        if (!state.layers.length) return;
        var count = state.layers.length;
        var columns = count === 1 ? 1 : (count <= 4 ? 2 : 3);
        var rows = Math.ceil(count / columns);
        var cellWidth = 100 / columns;
        var cellHeight = 100 / rows;
        state.layers.forEach(function (layer, index) {
          var column = index % columns;
          var row = Math.floor(index / columns);
          if (count === 1 && layer.type === 'image') {
            layer.width = 72;
            layer.height = 84;
          } else {
            layer.width = Math.min(count === 1 ? 72 : cellWidth * .72, cellWidth * .82, 76);
            layer.height = preferredHeight(state, layer, layer.width);
            if (layer.height > cellHeight * .78) {
              layer.width = layer.width * (cellHeight * .78) / layer.height;
              layer.height = cellHeight * .78;
            }
          }
          layer.x = column * cellWidth + (cellWidth - layer.width) / 2;
          layer.y = row * cellHeight + (cellHeight - layer.height) / 2;
          clampLayer(layer);
          applyLayer(state, layer);
        });
        updateState(state);
      }

      function applyLayer(state, layer) {
        layer.element.style.left = layer.x + '%';
        layer.element.style.top = layer.y + '%';
        layer.element.style.width = layer.width + '%';
        layer.element.style.height = layer.height + '%';
        if (layer.type === 'text' && layer.textNode) {
          var w = state.zone.clientWidth * layer.width / 100;
          var h = state.zone.clientHeight * layer.height / 100;
          layer.textNode.style.fontSize = Math.max(10, Math.min(w * .18, h * .68)) + 'px';
        }
      }

      function clampLayer(layer) {
        layer.width = clamp(layer.width, 5, 300);
        layer.height = clamp(layer.height, 5, 300);
        layer.x = clamp(layer.x, -layer.width + 5, 95);
        layer.y = clamp(layer.y, -layer.height + 5, 95);
      }

      function selectLayer(state, layer) {
        state.selected = layer;
        state.layers.forEach(function (candidate) { candidate.element.classList.toggle('is-active', candidate === layer); });
        renderList(state);
      }

      function removeLayer(state, layer) {
        var index = state.layers.indexOf(layer);
        if (index < 0) return;
        state.layers.splice(index, 1);
        layer.element.remove();
        if (layer.slot) { layer.slot.value = ''; delete layer.slot.dataset.layerId; }
        if (layer.url) URL.revokeObjectURL(layer.url);
        if (layer === state.textLayer) { state.textLayer = null; state.textInput.value = ''; }
        state.selected = state.layers[index] || state.layers[index - 1] || null;
        if (state.selected) state.selected.element.classList.add('is-active');
        renderList(state);
        refreshState(state);
        updateState(state);
      }

      function renderList(state) {
        state.list.innerHTML = '';
        state.layers.forEach(function (layer) {
          var item = document.createElement('div');
          var label = document.createElement('span');
          var remove = document.createElement('button');
          item.className = 'dual-layer-item' + (layer === state.selected ? ' is-active' : '');
          label.textContent = layer.type === 'text' ? 'Text: ' + state.textInput.value : layer.file.name;
          remove.type = 'button';
          remove.textContent = 'Remove';
          item.appendChild(label);
          item.appendChild(remove);
          item.addEventListener('click', function (event) { if (event.target !== remove) selectLayer(state, layer); });
          remove.addEventListener('click', function () { removeLayer(state, layer); });
          state.list.appendChild(item);
        });
      }

      function refreshState(state) {
        if (state.empty) state.empty.hidden = state.layers.length > 0;
      }

      function updateState(state) {
        var exportKey = JSON.stringify([state.layers.map(function (layer) { return [layer.id, layer.x, layer.y, layer.width, layer.height, layer.z]; }), state.textInput.value, state.fontInput.value, state.colorInput.value]);
        if (state.exportKey !== exportKey) invalidatePreview();
        state.exportKey = exportKey;
        var serialized = state.layers.map(function (layer, index) {
          return (layer.type === 'text' ? 'T' : 'I') + (index + 1) + ':' + round(layer.x) + ',' + round(layer.y) + ',' + round(layer.width) + ',' + round(layer.height);
        }).join('|');
        if (state.textLayer) serialized += '|F:' + state.fontInput.value;
        if (state.layoutInput.value !== serialized) invalidatePreview();
        state.layoutInput.value = serialized;
        renderDualFinishedPreview();
      }

      function setDualFinishedPreviewVisibility(visible) {
        if (!finishedPreview) return;
        finishedPreview.hidden = !visible;
        if (finishedToggle) {
          finishedToggle.textContent = visible ? 'Hide finished preview' : 'Show finished preview';
          finishedToggle.setAttribute('aria-expanded', visible ? 'true' : 'false');
        }
        document.body.classList.toggle('custom-preview-open', visible);
        if (visible) {
          previouslyFocused = document.activeElement;
          renderDualFinishedPreview();
          var closeButton = finishedPreview.querySelector('.custom-preview-header [data-dual-finished-close]');
          if (closeButton) closeButton.focus();
        } else if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
          previouslyFocused.focus();
        }
      }

      function renderDualFinishedPreview() {
        var hasArtwork = false;
        states.forEach(function (state) {
          var targets = Array.prototype.slice.call(root.querySelectorAll('[data-dual-finished-zone][data-side="' + state.side + '"], [data-dual-inline-zone][data-side="' + state.side + '"]'));
          targets.forEach(function (target) {
            target.innerHTML = '';
            state.layers.forEach(function (layer) {
              var clone = document.createElement('div');
              clone.className = 'finished-artwork-layer' + (layer.type === 'text' ? ' finished-text-layer' : '');
              clone.style.zIndex = layer.z;
              clone.style.left = layer.x + '%';
              clone.style.top = layer.y + '%';
              clone.style.width = layer.width + '%';
              clone.style.height = layer.height + '%';
              if (layer.type === 'text') {
                var text = document.createElement('span');
                text.textContent = state.textInput.value;
                text.style.color = state.colorInput.value;
                text.style.fontFamily = dualFontStack(state.fontInput.value);
                text.style.fontSize = Math.max(7, Math.min(target.clientWidth * layer.width / 100 * .18, target.clientHeight * layer.height / 100 * .68)) + 'px';
                clone.appendChild(text);
              } else {
                var image = document.createElement('img');
                image.src = layer.url;
                image.alt = '';
                clone.appendChild(image);
              }
              target.appendChild(clone);
            });
          });
          if (state.layers.length) hasArtwork = true;
        });
        if (finishedEmpty) finishedEmpty.hidden = hasArtwork;
        if (inlinePreviewEmpty) inlinePreviewEmpty.hidden = hasArtwork;
      }

      function invalidatePreview() {
        form.querySelectorAll('[data-production-file]').forEach(function (input) { input.remove(); });
        previewFile.value = '';
        delete form.dataset.dualPreviewReady;
      }

      function showError(message) { if (errorBox) errorBox.textContent = message; }

      function createCombinedPreview(editorStates) {
        var designCanvas = inlinePreviewStage || editorStates[0].canvas;
        var canvasRect = designCanvas.getBoundingClientRect();
        var combined = document.createElement('canvas');
        var context = combined.getContext('2d');
        var productImage = designCanvas.querySelector('.dual-product-image');
        var baseSource = productImage ? (productImage.currentSrc || productImage.src) : '';
        var imageLayers = [];
        editorStates.forEach(function (state) {
          state.layers.forEach(function (layer) { if (layer.type === 'image') imageLayers.push(layer); });
        });
        combined.width = 1600;
        combined.height = Math.max(1, Math.round(combined.width * canvasRect.height / Math.max(1, canvasRect.width)));

        return Promise.all([baseSource ? loadImage(baseSource) : Promise.resolve(null)].concat(imageLayers.map(function (layer) { return loadImage(layer.url); }))).then(function (loaded) {
          context.fillStyle = '#f0eef2';
          context.fillRect(0, 0, combined.width, combined.height);
          if (loaded[0]) drawContained(context, loaded[0], 0, 0, combined.width, combined.height);
          var scaleX = combined.width / Math.max(1, canvasRect.width);
          var scaleY = combined.height / Math.max(1, canvasRect.height);
          var loadedArtwork = {};
          imageLayers.forEach(function (layer, index) { loadedArtwork[layer.id] = loaded[index + 1]; });

          editorStates.forEach(function (state) {
            var previewZone = root.querySelector('[data-dual-inline-zone][data-side="' + state.side + '"]') || state.zone;
            var zoneRect = previewZone.getBoundingClientRect();
            var printLeft = (zoneRect.left - canvasRect.left) * scaleX;
            var printTop = (zoneRect.top - canvasRect.top) * scaleY;
            var printWidth = zoneRect.width * scaleX;
            var printHeight = zoneRect.height * scaleY;
            context.save();
            context.beginPath();
            context.rect(printLeft, printTop, printWidth, printHeight);
            context.clip();
            state.layers.slice().sort(function (a, b) { return a.z - b.z; }).forEach(function (layer) {
              var left = printLeft + layer.x / 100 * printWidth;
              var top = printTop + layer.y / 100 * printHeight;
              var width = layer.width / 100 * printWidth;
              var height = layer.height / 100 * printHeight;
              if (layer.type === 'image') context.drawImage(loadedArtwork[layer.id], left, top, width, height);
              else drawText(context, state.textInput.value, left, top, width, height, state.colorInput.value, dualFontStack(state.fontInput.value));
            });
            context.restore();
          });

          return new Promise(function (resolve, reject) {
            combined.toBlob(function (blob) {
              if (!blob) { reject(new Error('Preview export failed')); return; }
              resolve(new File([blob], 'creativemoro-front-back-design.png', { type: 'image/png' }));
            }, 'image/png');
          });
        });
      }

      function loadImage(source) {
        return new Promise(function (resolve, reject) {
          var image = new Image();
          if (!/^blob:|^data:/i.test(source)) image.crossOrigin = 'anonymous';
          image.onload = function () { resolve(image); };
          image.onerror = reject;
          image.src = source;
        });
      }

      function drawContained(context, image, left, top, width, height) {
        var scale = Math.min(width / image.naturalWidth, height / image.naturalHeight);
        var drawWidth = image.naturalWidth * scale;
        var drawHeight = image.naturalHeight * scale;
        context.drawImage(image, left + (width - drawWidth) / 2, top + (height - drawHeight) / 2, drawWidth, drawHeight);
      }

      function drawText(context, value, left, top, width, height, color, family) {
        context.save();
        context.fillStyle = color;
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.font = Math.max(12, Math.min(width * .18, height * .65)) + 'px ' + family;
        context.fillText(value, left + width / 2, top + height / 2, width * .96);
        context.restore();
      }

      function round(value) { return Math.round(value * 10) / 10; }
      function clamp(value, minimum, maximum) { return Math.min(maximum, Math.max(minimum, value)); }
      states.forEach(function (state) { refreshState(state); updateState(state); });
    });
  }

  function initCustomDesigners() {
    document.querySelectorAll('[data-custom-designer]').forEach(function (root) {
      var picker = root.querySelector('[data-artwork-picker]');
      var slots = Array.prototype.slice.call(root.querySelectorAll('[data-artwork-slot]'));
      var zone = root.querySelector('[data-print-zone]');
      var emptyZone = root.querySelector('[data-print-zone-empty]');
      var emptyList = root.querySelector('[data-artwork-empty]');
      var list = root.querySelector('[data-artwork-list]');
      var layoutInput = root.querySelector('[data-design-layout]');
      var designPreviewFile = root.querySelector('[data-design-preview-file]');
      var designCanvas = root.querySelector('[data-design-canvas]');
      var form = root.querySelector('form');
      var textInput = root.querySelector('[data-design-text]');
      var textFont = root.querySelector('[data-text-font]');
      var textColor = root.querySelector('[data-text-color]');
      var studioLayout = root.querySelector('[data-custom-studio-layout]');
      var toolsColumn = root.querySelector('[data-custom-tools-column]');
      var canvasColumn = root.querySelector('[data-custom-canvas-column]');
      var buyCard = root.querySelector('[data-custom-buy-card]');
      var productAnchor = root.querySelector('[data-custom-product-anchor]');
      var mobileStudio = window.matchMedia('(max-width: 720px)');
      var finishedPreview = root.querySelector('[data-finished-preview]');
      var finishedZone = root.querySelector('[data-finished-print-zone]');
      var finishedEmpty = root.querySelector('[data-finished-empty]');
      var inlineProductStage = root.querySelector('[data-inline-product-stage]');
      var inlineFinishedZone = root.querySelector('[data-inline-finished-zone]');
      var inlineFinishedEmpty = root.querySelector('[data-inline-finished-empty]');
      var finishedScroll = root.querySelector('[data-finished-scroll]');
      var finishedCloseButtons = Array.prototype.slice.call(root.querySelectorAll('[data-finished-close]'));
      var mobileToolbar = root.querySelector('[data-mobile-editor-toolbar]');
      var mobileToolbarButtons = mobileToolbar ? Array.prototype.slice.call(mobileToolbar.querySelectorAll('[data-mobile-editor-target]')) : [];
      var finishedPreviouslyFocused = null;
      var fullSurfaceMode = root.hasAttribute('data-blanket-mockup');
      if (!picker || !slots.length || !zone || !list || !layoutInput || !designPreviewFile || !designCanvas || !form || !textInput || !textFont || !textColor) return;

      function setMobileEditorPanel(panel, shouldScroll) {
        if (panel === 'preview') {
          if (finishedScroll) finishedScroll.click();
          else if (inlineProductStage) inlineProductStage.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        root.dataset.mobileActivePanel = panel;
        mobileToolbarButtons.forEach(function (button) {
          var active = button.dataset.mobileEditorTarget === panel;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (shouldScroll && mobileStudio.matches && toolsColumn) {
          window.requestAnimationFrame(function () { toolsColumn.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); });
        }
      }

      mobileToolbarButtons.forEach(function (button) {
        button.addEventListener('click', function () { setMobileEditorPanel(button.dataset.mobileEditorTarget, true); });
      });
      setMobileEditorPanel(root.dataset.mobileActivePanel || 'position', false);

      function syncResponsiveStudioOrder() {
        if (!studioLayout || !toolsColumn || !canvasColumn || !buyCard || !productAnchor) return;
        if (mobileStudio.matches) {
          studioLayout.insertBefore(buyCard, studioLayout.firstElementChild);
          buyCard.insertBefore(canvasColumn, productAnchor.nextSibling);
          buyCard.insertBefore(toolsColumn, canvasColumn.nextSibling);
        } else {
          studioLayout.insertBefore(toolsColumn, studioLayout.firstElementChild);
          studioLayout.insertBefore(canvasColumn, buyCard);
          studioLayout.appendChild(buyCard);
        }
      }
      syncResponsiveStudioOrder();
      if (mobileStudio.addEventListener) mobileStudio.addEventListener('change', syncResponsiveStudioOrder);
      else if (mobileStudio.addListener) mobileStudio.addListener(syncResponsiveStudioOrder);

      var layers = [];
      var activeLayer = null;
      var textLayer = null;
      var layerSequence = 0;
      var zSequence = 10;
      var finishedPreviewFrame = 0;
      var responsiveRenderFrame = 0;
      var preparingPreview = false;

      window.addEventListener('resize', function () {
        if (responsiveRenderFrame) return;
        responsiveRenderFrame = window.requestAnimationFrame(function () {
          responsiveRenderFrame = 0;
          layers.forEach(applyLayerStyle);
          renderFinishedPreview();
        });
      });

      picker.addEventListener('change', function () {
        addFiles(Array.prototype.slice.call(picker.files || []));
        picker.value = '';
      });

      textInput.addEventListener('input', syncTextLayer);
      textFont.addEventListener('change', syncTextLayer);
      textColor.addEventListener('input', syncTextLayer);
      root.querySelectorAll('[data-text-color-choice]').forEach(function (button) {
        button.addEventListener('click', function () {
          textColor.value = button.dataset.textColorChoice;
          syncTextLayer();
        });
      });

      root.querySelector('[data-design-arrange]').addEventListener('click', arrangeLayers);
      root.querySelector('[data-design-reset]').addEventListener('click', arrangeLayers);
      if (finishedScroll && finishedPreview) finishedScroll.addEventListener('click', toggleFinishedPreview);
      finishedCloseButtons.forEach(function (button) {
        button.addEventListener('click', function () { setFinishedPreviewVisibility(false); });
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && finishedPreview && !finishedPreview.hidden) setFinishedPreviewVisibility(false);
      });
      root.addEventListener('change', function (event) {
        if (event.target.classList.contains('option-input')) invalidateDesignPreview();
      });
      root.querySelectorAll('[data-design-position]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (activeLayer) positionLayer(activeLayer, button.dataset.position);
        });
      });
      root.querySelector('[data-design-front]').addEventListener('click', function () {
        if (!activeLayer) return;
        activeLayer.z = ++zSequence;
        activeLayer.element.style.zIndex = activeLayer.z;
        updateLayoutValue();
      });
      root.querySelector('[data-design-delete]').addEventListener('click', function () {
        if (activeLayer) removeLayer(activeLayer);
      });

      form.addEventListener('submit', function (event) {
        updateLayoutValue();
        if (!layers.length) {
          event.preventDefault();
          emptyList.hidden = false;
          emptyList.textContent = 'Please upload an image or add custom text before adding this product to the cart.';
          emptyList.style.color = '#b4232e';
          root.querySelector('.artwork-upload-button').scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        if (form.dataset.previewReady === 'true' && designPreviewFile.files && designPreviewFile.files.length) return;

        event.preventDefault();
        if (preparingPreview) return;
        preparingPreview = true;

        var submitButton = event.submitter || form.querySelector('[data-add-to-cart]');
        var originalText = submitButton ? submitButton.textContent : '';
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.classList.add('is-loading');
          submitButton.textContent = 'Preparing your design...';
        }

        var groups = [{ name: fullSurfaceMode ? 'Blanket print PNG' : 'Front print PNG', layers: layers,
          zone: fullSurfaceMode ? zone : (inlineFinishedZone || zone), fit: fullSurfaceMode ? 'contain' : 'fill', text: textInput.value, color: textColor.value, font: fontStack(textFont.value) }];
        var signature = productionSignature(form, groups);
        Promise.all([createDesignPreviewFile(), Promise.resolve().then(function () { return prepareProductionFiles(form, groups); })]).then(function (results) {
          if (signature !== productionSignature(form, groups)) throw new Error('Design changed during export. Please try again.');
          var file = results[0];
          var transfer = new DataTransfer();
          transfer.items.add(file);
          designPreviewFile.files = transfer.files;
          form.dataset.previewReady = 'true';
          form.dataset.previewLayout = layoutInput.value;
          preparingPreview = false;
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.classList.remove('is-loading');
            submitButton.textContent = originalText;
          }
          form.requestSubmit(submitButton || undefined);
        }).catch(function () {
          preparingPreview = false;
          invalidateDesignPreview();
          emptyList.hidden = false;
          emptyList.textContent = 'We could not prepare the finished preview. Please try again.';
          emptyList.style.color = '#b4232e';
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.classList.remove('is-loading');
            submitButton.textContent = originalText;
          }
        });
      });

      function addFiles(files) {
        var imageFiles = files.filter(function (file) {
          return file && /^image\/(png|jpe?g|webp)$/i.test(file.type);
        });
        var availableBefore = slots.filter(function (candidate) {
          return !candidate.dataset.layerId;
        }).length;

        imageFiles.forEach(function (file) {
          var slot = slots.find(function (candidate) {
            return !candidate.dataset.layerId;
          });
          if (!slot) return;

          try {
            var transfer = new DataTransfer();
            transfer.items.add(file);
            slot.files = transfer.files;
          } catch (error) {
            return;
          }

          var layer = createLayer(file, slot);
          layers.push(layer);
          slot.dataset.layerId = layer.id;
          zone.appendChild(layer.element);
          selectLayer(layer);
        });

        if (imageFiles.length > availableBefore) {
          emptyList.hidden = false;
          emptyList.textContent = 'A maximum of six artwork files can be added.';
        }

        refreshEmptyStates();
        renderLayerList();
        arrangeLayers();
      }

      function createLayer(file, slot) {
        var id = 'artwork-' + (++layerSequence);
        var url = URL.createObjectURL(file);
        var element = document.createElement('div');
        var image = document.createElement('img');

        element.className = 'artwork-layer';
        element.tabIndex = 0;
        element.setAttribute('role', 'button');
        element.setAttribute('aria-label', 'Move ' + file.name);
        element.dataset.layerId = id;
        image.src = url;
        image.alt = '';
        image.draggable = false;
        element.appendChild(image);
        var handles = createResizeHandles(element);

        var layer = {
          id: id,
          type: 'image',
          file: file,
          slot: slot,
          url: url,
          element: element,
          image: image,
          x: fullSurfaceMode ? 0 : 15,
          y: fullSurfaceMode ? 0 : 15,
          width: fullSurfaceMode ? 100 : 70,
          height: fullSurfaceMode ? 100 : 70,
          z: ++zSequence
        };

        element.style.zIndex = layer.z;
        applyLayerStyle(layer);
        bindLayerInteractions(layer, handles);
        image.addEventListener('load', function () {
          arrangeLayers();
        });

        return layer;
      }

      function createTextLayer() {
        var id = 'text-' + (++layerSequence);
        var element = document.createElement('div');
        var textNode = document.createElement('span');

        element.className = 'artwork-layer artwork-text-layer';
        element.tabIndex = 0;
        element.setAttribute('role', 'button');
        element.setAttribute('aria-label', 'Move custom text');
        element.dataset.layerId = id;
        element.appendChild(textNode);
        var handles = createResizeHandles(element);

        var layer = {
          id: id,
          type: 'text',
          element: element,
          textNode: textNode,
          x: 15,
          y: 15,
          width: 70,
          height: 24,
          z: ++zSequence
        };

        bindLayerInteractions(layer, handles);
        applyLayerStyle(layer);
        return layer;
      }

      function createResizeHandles(element) {
        return ['nw', 'n', 'ne', 'e', 'se', 's', 'sw', 'w'].map(function (direction) {
          var handle = document.createElement('span');
          handle.className = 'artwork-resize-handle artwork-resize-' + direction;
          handle.dataset.resizeDirection = direction;
          handle.setAttribute('aria-hidden', 'true');
          element.appendChild(handle);
          return handle;
        });
      }

      function syncTextLayer() {
        var value = textInput.value.trim();
        var created = false;
        if (!value) {
          if (textLayer) removeLayer(textLayer);
          return;
        }

        if (!textLayer) {
          textLayer = createTextLayer();
          layers.push(textLayer);
          zone.appendChild(textLayer.element);
          selectLayer(textLayer);
          created = true;
        }

        invalidateDesignPreview();
        textLayer.textNode.textContent = value;
        textLayer.textNode.style.fontFamily = fontStack(textFont.value);
        textLayer.textNode.style.color = textColor.value;
        applyLayerStyle(textLayer);
        refreshEmptyStates();
        renderLayerList();
        if (created) centerLayer(textLayer);
        else updateLayoutValue();
      }

      function fontStack(fontName) {
        if (fontName === 'Georgia' || fontName === 'Times New Roman') return '"' + fontName + '", serif';
        if (fontName === 'Courier New') return '"Courier New", monospace';
        if (fontName === 'Brush Script MT') return '"Brush Script MT", cursive';
        return '"' + fontName + '", Arial, sans-serif';
      }

      function bindLayerInteractions(layer, handles) {
        layer.element.addEventListener('pointerdown', function (event) {
          if (event.target.closest('.artwork-resize-handle')) return;
          startDrag(event, layer);
        });
        handles.forEach(function (handle) {
          handle.addEventListener('pointerdown', function (event) {
            event.stopPropagation();
            startResize(event, layer, handle.dataset.resizeDirection);
          });
        });
        layer.element.addEventListener('focus', function () {
          selectLayer(layer);
        });
        layer.element.addEventListener('keydown', function (event) {
          var step = event.shiftKey ? 5 : 1;
          if (event.key === 'Delete' || event.key === 'Backspace') {
            event.preventDefault();
            removeLayer(layer);
            return;
          }
          if (event.key === 'ArrowLeft') layer.x -= step;
          else if (event.key === 'ArrowRight') layer.x += step;
          else if (event.key === 'ArrowUp') layer.y -= step;
          else if (event.key === 'ArrowDown') layer.y += step;
          else return;
          event.preventDefault();
          clampLayer(layer);
          applyLayerStyle(layer);
          updateLayoutValue();
        });
      }

      function startDrag(event, layer) {
        if (event.button !== undefined && event.button !== 0) return;
        event.preventDefault();
        selectLayer(layer);

        var zoneRect = zone.getBoundingClientRect();
        var startX = event.clientX;
        var startY = event.clientY;
        var startLeft = layer.x / 100 * zoneRect.width;
        var startTop = layer.y / 100 * zoneRect.height;

        function move(moveEvent) {
          var visibleEdge = 24;
          var nextLeft = clamp(startLeft + moveEvent.clientX - startX, -layer.element.offsetWidth + visibleEdge, zoneRect.width - visibleEdge);
          var nextTop = clamp(startTop + moveEvent.clientY - startY, -layer.element.offsetHeight + visibleEdge, zoneRect.height - visibleEdge);
          layer.x = nextLeft / zoneRect.width * 100;
          layer.y = nextTop / zoneRect.height * 100;
          applyLayerStyle(layer);
          updateLayoutValue();
        }

        function stop() {
          window.removeEventListener('pointermove', move);
          window.removeEventListener('pointerup', stop);
          window.removeEventListener('pointercancel', stop);
        }

        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', stop);
        window.addEventListener('pointercancel', stop);
      }

      function startResize(event, layer, direction) {
        if (event.button !== undefined && event.button !== 0) return;
        event.preventDefault();
        selectLayer(layer);

        var zoneRect = zone.getBoundingClientRect();
        var startX = event.clientX;
        var startY = event.clientY;
        var startLeft = layer.x / 100 * zoneRect.width;
        var startTop = layer.y / 100 * zoneRect.height;
        var startWidth = layer.width / 100 * zoneRect.width;
        var startHeight = layer.height / 100 * zoneRect.height;
        var startRight = startLeft + startWidth;
        var startBottom = startTop + startHeight;
        var minimumWidth = Math.min(36, zoneRect.width);
        var minimumHeight = Math.min(28, zoneRect.height);

        function move(moveEvent) {
          var deltaX = moveEvent.clientX - startX;
          var deltaY = moveEvent.clientY - startY;
          var nextLeft = startLeft;
          var nextTop = startTop;
          var nextWidth = startWidth;
          var nextHeight = startHeight;

          if (direction.indexOf('e') >= 0) {
            nextWidth = clamp(startWidth + deltaX, minimumWidth, zoneRect.width * 3);
          }
          if (direction.indexOf('w') >= 0) {
            nextLeft = clamp(startLeft + deltaX, -zoneRect.width * 2, startRight - minimumWidth);
            nextWidth = startRight - nextLeft;
          }
          if (direction.indexOf('s') >= 0) {
            nextHeight = clamp(startHeight + deltaY, minimumHeight, zoneRect.height * 3);
          }
          if (direction.indexOf('n') >= 0) {
            nextTop = clamp(startTop + deltaY, -zoneRect.height * 2, startBottom - minimumHeight);
            nextHeight = startBottom - nextTop;
          }

          layer.x = nextLeft / zoneRect.width * 100;
          layer.y = nextTop / zoneRect.height * 100;
          layer.width = nextWidth / zoneRect.width * 100;
          layer.height = nextHeight / zoneRect.height * 100;
          applyLayerStyle(layer);
          updateLayoutValue();
        }

        function stop() {
          window.removeEventListener('pointermove', move);
          window.removeEventListener('pointerup', stop);
          window.removeEventListener('pointercancel', stop);
        }

        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', stop);
        window.addEventListener('pointercancel', stop);
      }

      function arrangeLayers() {
        if (!layers.length) return;
        var count = layers.length;

        // Blankets are edge-to-edge by default. The layer remains fully
        // editable, but the first uploaded artwork immediately fills the
        // complete printable surface in both inline and enlarged previews.
        if (fullSurfaceMode && count === 1 && layers[0].type === 'image') {
          var blanketLayer = layers[0];
          blanketLayer.x = 0;
          blanketLayer.y = 0;
          blanketLayer.width = 100;
          blanketLayer.height = 100;
          applyLayerStyle(blanketLayer);
          updateLayoutValue();
          return;
        }

        var columns = count === 1 ? 1 : (count <= 4 ? 2 : 3);
        var rows = Math.ceil(count / columns);
        var cellWidth = 100 / columns;
        var cellHeight = 100 / rows;

        layers.forEach(function (layer, index) {
          var column = index % columns;
          var row = Math.floor(index / columns);
          var maximumWidth = cellWidth * .82;
          var maximumHeight = cellHeight * .78;
          layer.width = Math.min(count === 1 ? 72 : cellWidth * .72, maximumWidth, 76);
          layer.height = preferredLayerHeight(layer, layer.width);
          if (layer.height > maximumHeight) {
            layer.width = layer.width * maximumHeight / layer.height;
            layer.height = maximumHeight;
          }
          layer.x = column * cellWidth + (cellWidth - layer.width) / 2;
          layer.y = row * cellHeight + (cellHeight - layer.height) / 2;
          clampLayer(layer);
          applyLayerStyle(layer);
        });
        updateLayoutValue();
      }

      function preferredLayerHeight(layer, widthPercent) {
        if (layer.type === 'image' && layer.image && layer.image.naturalWidth && layer.image.naturalHeight) {
          var zoneRatio = zone.clientWidth && zone.clientHeight ? zone.clientWidth / zone.clientHeight : 1;
          return widthPercent * zoneRatio * layer.image.naturalHeight / layer.image.naturalWidth;
        }
        return Math.max(16, Math.min(30, widthPercent * .34));
      }

      function centerLayer(layer) {
        positionLayer(layer, 'center');
      }

      function positionLayer(layer, position) {
        var inset = 4;
        var horizontal = position.indexOf('left') >= 0 ? 'left' : (position.indexOf('right') >= 0 ? 'right' : 'center');
        var vertical = position.indexOf('top') >= 0 ? 'top' : (position.indexOf('bottom') >= 0 ? 'bottom' : 'middle');
        layer.x = horizontal === 'left' ? inset : (horizontal === 'right' ? 100 - layer.width - inset : (100 - layer.width) / 2);
        layer.y = vertical === 'top' ? inset : (vertical === 'bottom' ? 100 - layer.height - inset : (100 - layer.height) / 2);
        clampLayer(layer);
        applyLayerStyle(layer);
        updateLayoutValue();
      }

      function clampLayer(layer) {
        layer.width = clamp(layer.width, 5, 300);
        layer.height = clamp(layer.height, 5, 300);
        layer.x = clamp(layer.x, -layer.width + 5, 95);
        layer.y = clamp(layer.y, -layer.height + 5, 95);
      }

      function applyLayerStyle(layer) {
        layer.element.style.left = layer.x + '%';
        layer.element.style.top = layer.y + '%';
        layer.element.style.width = layer.width + '%';
        layer.element.style.height = layer.height + '%';
        layer.element.style.zIndex = layer.z;
        if (layer.type === 'text' && layer.textNode) {
          var availableWidth = zone.clientWidth * layer.width / 100;
          var availableHeight = zone.clientHeight * layer.height / 100;
          layer.textNode.style.fontSize = Math.max(10, Math.min(availableWidth * .18, availableHeight * .68)) + 'px';
        }
      }

      function selectLayer(layer) {
        activeLayer = layer;
        layers.forEach(function (candidate) {
          candidate.element.classList.toggle('is-active', candidate === layer);
        });
        renderLayerList();
      }

      function removeLayer(layer) {
        var index = layers.indexOf(layer);
        if (index < 0) return;
        layers.splice(index, 1);
        layer.element.remove();
        if (layer.slot) {
          layer.slot.value = '';
          delete layer.slot.dataset.layerId;
        }
        if (layer.url) URL.revokeObjectURL(layer.url);
        if (layer.type === 'text') {
          textLayer = null;
          textInput.value = '';
        }
        activeLayer = layers.length ? layers[Math.min(index, layers.length - 1)] : null;
        if (activeLayer) activeLayer.element.classList.add('is-active');
        refreshEmptyStates();
        renderLayerList();
        arrangeLayers();
        updateLayoutValue();
      }

      function renderLayerListLegacy() {
        list.innerHTML = '';
        layers.forEach(function (layer) {
          var item = document.createElement('div');
          var image = document.createElement('img');
          var name = document.createElement('span');
          var remove = document.createElement('button');

          item.className = 'artwork-list-item' + (layer === activeLayer ? ' is-active' : '');
          item.tabIndex = 0;
          item.setAttribute('role', 'button');
          image.src = layer.url;
          image.alt = '';
          name.textContent = layer.file.name;
          remove.type = 'button';
          remove.textContent = '×';
          remove.setAttribute('aria-label', 'Remove ' + layer.file.name);
          item.appendChild(image);
          item.appendChild(name);
          item.appendChild(remove);
          item.addEventListener('click', function (event) {
            if (event.target === remove) return;
            selectLayer(layer);
            layer.element.focus();
          });
          item.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              selectLayer(layer);
              layer.element.focus();
            }
          });
          remove.addEventListener('click', function () {
            removeLayer(layer);
          });
          list.appendChild(item);
        });
      }

      function renderLayerList() {
        list.innerHTML = '';
        layers.forEach(function (layer) {
          var item = document.createElement('div');
          var preview;
          var name = document.createElement('span');
          var remove = document.createElement('button');
          var layerName;

          item.className = 'artwork-list-item' + (layer === activeLayer ? ' is-active' : '');
          item.tabIndex = 0;
          item.setAttribute('role', 'button');

          if (layer.type === 'text') {
            preview = document.createElement('div');
            preview.className = 'artwork-text-preview';
            preview.textContent = 'Aa';
            preview.style.color = textColor.value;
            preview.style.fontFamily = fontStack(textFont.value);
            layerName = 'Text: ' + textInput.value;
          } else {
            preview = document.createElement('img');
            preview.src = layer.url;
            preview.alt = '';
            layerName = layer.file.name;
          }

          name.textContent = layerName;
          remove.type = 'button';
          remove.textContent = 'X';
          remove.setAttribute('aria-label', 'Remove ' + layerName);
          item.appendChild(preview);
          item.appendChild(name);
          item.appendChild(remove);
          item.addEventListener('click', function (event) {
            if (event.target === remove) return;
            selectLayer(layer);
            layer.element.focus();
          });
          item.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              selectLayer(layer);
              layer.element.focus();
            }
          });
          remove.addEventListener('click', function () {
            removeLayer(layer);
          });
          list.appendChild(item);
        });
      }

      function refreshEmptyStates() {
        var isEmpty = layers.length === 0;
        emptyZone.hidden = !isEmpty;
        emptyList.hidden = !isEmpty;
        if (isEmpty) {
          emptyList.textContent = 'No artwork or text added yet.';
          emptyList.style.color = '';
        }
      }

      function updateLayoutValue() {
        var serializedLayout = layers.map(function (layer, index) {
          var typeCode = layer.type === 'text' ? 'T' : 'I';
          return typeCode + (index + 1) + ':' + round(layer.x) + ',' + round(layer.y) + ',' + round(layer.width) + ',' + round(layer.height) + ',' + layer.z;
        }).join('|');
        layoutInput.value = serializedLayout;
        if (form.dataset.previewLayout !== serializedLayout) {
          invalidateDesignPreview();
        }
        scheduleFinishedPreview();
      }

      function invalidateDesignPreview() {
        form.querySelectorAll('[data-production-file]').forEach(function (input) { input.remove(); });
        designPreviewFile.value = '';
        delete form.dataset.previewReady;
        delete form.dataset.previewLayout;
      }

      function toggleFinishedPreview() {
        setFinishedPreviewVisibility(finishedPreview.hidden);
      }

      function setFinishedPreviewVisibility(visible) {
        if (!finishedPreview) return;
        finishedPreview.hidden = !visible;
        if (finishedScroll) {
          finishedScroll.textContent = visible ? 'Hide finished preview' : 'Show finished preview';
          finishedScroll.setAttribute('aria-expanded', visible ? 'true' : 'false');
        }
        document.body.classList.toggle('custom-preview-open', visible);
        if (visible) {
          finishedPreviouslyFocused = document.activeElement;
          renderFinishedPreview();
          var closeButton = finishedPreview.querySelector('.custom-preview-header [data-finished-close]');
          if (closeButton) closeButton.focus();
        } else if (finishedPreviouslyFocused && typeof finishedPreviouslyFocused.focus === 'function') {
          finishedPreviouslyFocused.focus();
        }
      }

      function scheduleFinishedPreview() {
        if ((!finishedZone && !inlineFinishedZone) || finishedPreviewFrame) return;
        finishedPreviewFrame = window.requestAnimationFrame(function () {
          finishedPreviewFrame = 0;
          renderFinishedPreview();
        });
      }

      function renderFinishedPreview() {
        [inlineFinishedZone, finishedZone].filter(Boolean).forEach(function (target) {
          target.innerHTML = '';
          layers.forEach(function (layer) {
            var clone = document.createElement('div');
            clone.className = 'finished-artwork-layer' + (layer.type === 'text' ? ' finished-text-layer' : '');
            clone.style.left = layer.x + '%';
            clone.style.top = layer.y + '%';
            clone.style.width = layer.width + '%';
            clone.style.height = layer.height + '%';
            clone.style.zIndex = layer.z;

            if (layer.type === 'text') {
              var text = document.createElement('span');
              text.textContent = textInput.value;
              text.style.color = textColor.value;
              text.style.fontFamily = fontStack(textFont.value);
              var previewWidth = (target.clientWidth || zone.clientWidth) * layer.width / 100;
              var previewHeight = (target.clientHeight || zone.clientHeight) * layer.height / 100;
              text.style.fontSize = Math.max(7, Math.min(previewWidth * .18, previewHeight * .68)) + 'px';
              clone.appendChild(text);
            } else {
              var image = document.createElement('img');
              image.src = layer.url;
              image.alt = '';
              clone.appendChild(image);
            }

            target.appendChild(clone);
          });
        });

        if (finishedEmpty) finishedEmpty.hidden = layers.length > 0;
        if (inlineFinishedEmpty) inlineFinishedEmpty.hidden = layers.length > 0;
      }

      function createDesignPreviewFile() {
        var previewCanvas = inlineProductStage || designCanvas;
        var previewZone = inlineFinishedZone || zone;
        var canvasRect = previewCanvas.getBoundingClientRect();
        var zoneRect = previewZone.getBoundingClientRect();
        var outputWidth = 1000;
        var outputHeight = Math.max(1, Math.round(outputWidth * canvasRect.height / Math.max(1, canvasRect.width)));
        var outputCanvas = document.createElement('canvas');
        var context = outputCanvas.getContext('2d');
        var productImage = previewCanvas.querySelector('.design-product-image');
        var baseSource = productImage ? (productImage.currentSrc || productImage.src) : '';
        var imageLayers = layers.filter(function (layer) { return layer.type === 'image'; });
        var imagePromises = imageLayers.map(function (layer) { return loadCanvasImage(layer.url); });

        outputCanvas.width = outputWidth;
        outputCanvas.height = outputHeight;

        return Promise.all([baseSource ? loadCanvasImage(baseSource) : Promise.resolve(null)].concat(imagePromises)).then(function (loadedImages) {
          context.fillStyle = window.getComputedStyle(previewCanvas).backgroundColor || '#ececef';
          context.fillRect(0, 0, outputWidth, outputHeight);
          if (loadedImages[0]) drawContainedImage(context, loadedImages[0], 0, 0, outputWidth, outputHeight);

          var scaleX = outputWidth / Math.max(1, canvasRect.width);
          var scaleY = outputHeight / Math.max(1, canvasRect.height);
          var printLeft = (zoneRect.left - canvasRect.left) * scaleX;
          var printTop = (zoneRect.top - canvasRect.top) * scaleY;
          var printWidth = zoneRect.width * scaleX;
          var printHeight = zoneRect.height * scaleY;
          var loadedArtwork = {};
          imageLayers.forEach(function (layer, index) {
            loadedArtwork[layer.id] = loadedImages[index + 1];
          });

          context.save();
          context.beginPath();
          context.rect(printLeft, printTop, printWidth, printHeight);
          context.clip();
          layers.slice().sort(function (a, b) { return a.z - b.z; }).forEach(function (layer) {
            var left = printLeft + layer.x / 100 * printWidth;
            var top = printTop + layer.y / 100 * printHeight;
            var width = layer.width / 100 * printWidth;
            var height = layer.height / 100 * printHeight;
            if (layer.type === 'image') {
              context.drawImage(loadedArtwork[layer.id], left, top, width, height);
            } else {
              drawCanvasText(context, textInput.value, left, top, width, height, textColor.value, fontStack(textFont.value));
            }
          });
          context.restore();
          return new Promise(function (resolve, reject) {
            outputCanvas.toBlob(function (blob) {
              if (!blob) {
                reject(new Error('Unable to export design preview.'));
                return;
              }
              resolve(new File([blob], 'creativemoro-custom-design.png', { type: 'image/png' }));
            }, 'image/png');
          });
        });
      }

      function loadCanvasImage(source) {
        return new Promise(function (resolve, reject) {
          var image = new Image();
          if (!/^blob:|^data:/i.test(source)) image.crossOrigin = 'anonymous';
          image.onload = function () { resolve(image); };
          image.onerror = function () { reject(new Error('Unable to load preview image.')); };
          image.src = source;
        });
      }

      function drawContainedImage(context, image, left, top, width, height) {
        var scale = Math.min(width / image.naturalWidth, height / image.naturalHeight);
        var drawWidth = image.naturalWidth * scale;
        var drawHeight = image.naturalHeight * scale;
        context.drawImage(image, left + (width - drawWidth) / 2, top + (height - drawHeight) / 2, drawWidth, drawHeight);
      }

      function drawCanvasText(context, value, left, top, width, height, color, family) {
        var words = String(value || '').split(/\s+/).filter(Boolean);
        var fontSize = Math.max(14, Math.min(width * .18, height * .68));
        var lines = [];
        var line = '';

        context.save();
        context.fillStyle = color;
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.font = fontSize + 'px ' + family;

        words.forEach(function (word) {
          var testLine = line ? line + ' ' + word : word;
          if (line && context.measureText(testLine).width > width * .94) {
            lines.push(line);
            line = word;
          } else {
            line = testLine;
          }
        });
        if (line) lines.push(line);
        if (!lines.length) lines.push('');

        var lineHeight = fontSize * 1.08;
        if (lineHeight * lines.length > height * .92) {
          fontSize = Math.max(10, fontSize * height * .92 / (lineHeight * lines.length));
          lineHeight = fontSize * 1.08;
          context.font = fontSize + 'px ' + family;
        }
        var firstLineY = top + height / 2 - (lines.length - 1) * lineHeight / 2;
        lines.forEach(function (textLine, index) {
          context.fillText(textLine, left + width / 2, firstLineY + index * lineHeight, width * .96);
        });
        context.restore();
      }

      function round(value) {
        return Math.round(value * 10) / 10;
      }

      function clamp(value, minimum, maximum) {
        return Math.min(maximum, Math.max(minimum, value));
      }

      refreshEmptyStates();
      updateLayoutValue();
    });
  }

  function initCartImageZoom() {
    var lightbox = document.querySelector('[data-cart-image-lightbox]');
    if (!lightbox) return;

    var image = lightbox.querySelector('[data-cart-image-lightbox-image]');
    var closeButton = lightbox.querySelector('.cart-image-lightbox-close');
    var previousFocus = null;

    function openLightbox(trigger) {
      if (!trigger || !trigger.dataset.cartImageSrc || !image) return;
      previousFocus = trigger;
      image.src = trigger.dataset.cartImageSrc;
      image.alt = trigger.dataset.cartImageAlt || 'Enlarged cart item preview';
      lightbox.hidden = false;
      document.body.classList.add('cart-image-lightbox-open');
      window.setTimeout(function () { if (closeButton) closeButton.focus(); }, 20);
    }

    function closeLightbox() {
      if (lightbox.hidden) return;
      lightbox.hidden = true;
      document.body.classList.remove('cart-image-lightbox-open');
      image.removeAttribute('src');
      image.alt = '';
      if (previousFocus && document.contains(previousFocus)) previousFocus.focus();
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-cart-image-zoom]');
      if (trigger) {
        event.preventDefault();
        openLightbox(trigger);
        return;
      }
      if (event.target.closest('[data-cart-image-lightbox-close]')) {
        event.preventDefault();
        closeLightbox();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || lightbox.hidden) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      closeLightbox();
    });
  }

  function initAjaxCart() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var panel = drawer.querySelector('.cart-drawer-panel');
    var content = drawer.querySelector('[data-cart-drawer-content]');
    var status = drawer.querySelector('[data-cart-status]');
    var rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    var noteSaveTimer = null;
    var lastSavedNote = '';

    function openDrawer(message) {
      if (message && status) status.textContent = message;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      window.setTimeout(function () {
        if (panel) panel.focus();
      }, 40);
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
      if (status) status.textContent = '';
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function propertyMarkup(properties) {
      if (!properties) return '';
      return Object.keys(properties).filter(function (key) {
        return key.charAt(0) !== '_' && properties[key];
      }).map(function (key) {
        var value = properties[key];
        if (key === 'Design preview') return '<small class="cart-design-included">Custom design: Included</small>';
        if (typeof value === 'string' && value.indexOf('/uploads/') >= 0) value = 'Uploaded file';
        return '<small>' + escapeHtml(key) + ': ' + escapeHtml(value) + '</small>';
      }).join('');
    }

    function setCartNoteStatus(message) {
      drawer.querySelectorAll('[data-cart-note-status]').forEach(function (node) {
        node.textContent = message;
      });
    }

    function saveCartNote(value) {
      window.clearTimeout(noteSaveTimer);
      setCartNoteStatus('Saving...');
      return fetch(rootUrl + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: value })
      }).then(function (response) {
        if (!response.ok) throw new Error('Unable to save the order note.');
        return response.json();
      }).then(function (cart) {
        lastSavedNote = cart.note || '';
        drawer.querySelectorAll('[data-cart-note]').forEach(function (field) {
          if (field.value !== lastSavedNote) field.value = lastSavedNote;
        });
        setCartNoteStatus('Note saved');
        return cart;
      }).catch(function (error) {
        setCartNoteStatus('Could not save. Please try again.');
        throw error;
      });
    }

    function renderCart(cart) {
      lastSavedNote = cart.note || '';
      document.querySelectorAll('[data-cart-item-count]').forEach(function (node) {
        node.textContent = cart.item_count;
      });
      drawer.querySelectorAll('[data-cart-drawer-count]').forEach(function (node) {
        node.textContent = '(' + cart.item_count + ')';
      });

      if (!content) return;
      if (!cart.items.length) {
        content.innerHTML = '<div class="cart-drawer-empty"><svg class="cart-empty-icon" viewBox="0 0 48 48" aria-hidden="true"><path d="M9 10h4l4 21h20l3-14H15M20 39a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm19 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"></path></svg><h3>Your cart is empty</h3><p>Add a personalized product and it will appear here.</p><a class="button button-primary" href="' + escapeHtml(rootUrl + 'collections/all') + '">Continue shopping</a></div>';
        return;
      }

      var items = cart.items.map(function (item) {
        var designPreview = item.properties && item.properties['Design preview'];
        var imageSource = designPreview || item.image;
        var imageAlt = designPreview ? 'Your custom design for ' + item.product_title : item.product_title;
        var image = imageSource ? '<button class="drawer-cart-image" type="button" data-cart-image-zoom data-cart-image-src="' + escapeHtml(imageSource) + '" data-cart-image-alt="' + escapeHtml(imageAlt) + '" aria-label="Enlarge image for ' + escapeHtml(item.product_title) + '"><img src="' + escapeHtml(imageSource) + '" alt="' + escapeHtml(imageAlt) + '" width="184" height="184"><span class="cart-image-zoom-label" aria-hidden="true">View</span></button>' : '<button class="drawer-cart-image" type="button" disabled aria-label="No preview image available"></button>';
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<small>' + escapeHtml(item.variant_title) + '</small>' : '';
        return '<article class="drawer-cart-item">' + image + '<div class="drawer-cart-info"><a href="' + escapeHtml(item.url) + '"><strong>' + escapeHtml(item.product_title) + '</strong></a>' + variant + propertyMarkup(item.properties) + '<div class="drawer-cart-controls"><div class="cart-quantity-control"><button type="button" data-cart-quantity data-cart-key="' + escapeHtml(item.key) + '" data-cart-quantity-value="' + Math.max(0, item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button><span>' + item.quantity + '</span><button type="button" data-cart-quantity data-cart-key="' + escapeHtml(item.key) + '" data-cart-quantity-value="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button></div><button class="drawer-remove" type="button" data-cart-quantity data-cart-key="' + escapeHtml(item.key) + '" data-cart-quantity-value="0">Remove</button><strong>' + formatMoney(item.final_line_price, cart.currency || 'USD') + '</strong></div></div></article>';
      }).join('');

      content.innerHTML = '<div class="cart-drawer-items">' + items + '</div><div class="cart-drawer-footer"><div class="cart-drawer-subtotal"><span>Subtotal</span><strong>' + formatMoney(cart.total_price, cart.currency || 'USD') + '</strong></div><label class="cart-note-field cart-drawer-note"><span>Order note</span><textarea rows="2" maxlength="500" placeholder="Add special instructions for your order" data-cart-note>' + escapeHtml(lastSavedNote) + '</textarea><small data-cart-note-status aria-live="polite">Saved automatically</small></label>' + ((cart.currency || 'USD') === 'USD' ? '<div class="free-shipping-status" role="status">' + (cart.total_price >= 3000 ? 'You qualify for free U.S. shipping!' : 'Add ' + formatMoney(3000 - cart.total_price, 'USD') + ' more for free U.S. shipping. Shipping below $30: $4.99.') + '</div>' : '<div class="free-shipping-status">Free U.S. shipping on orders of US$30 or more; US$4.99 below US$30.</div>') + '<div class="cart-quantity-offer" role="status"><strong>Buy 2 or more, get 10% off</strong><span>' + (cart.item_count >= 2 ? 'Your cart meets the 2-item offer requirement.' : 'Add 1 more item to qualify for 10% off.') + '</span></div><p>Taxes calculated at checkout.</p><a class="button button-primary" href="' + escapeHtml(rootUrl + 'checkout') + '" data-cart-checkout>Secure checkout</a><a class="drawer-view-cart" href="' + escapeHtml(rootUrl + 'cart') + '">View full cart</a></div>';
    }

    function fetchCart() {
      return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
        if (!response.ok) throw new Error('Unable to load the cart.');
        return response.json();
      });
    }

    function refreshCart(message) {
      return fetchCart().then(function (cart) {
        renderCart(cart);
        if (message && status) status.textContent = message;
        return cart;
      });
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-cart-open]');
      if (opener) {
        event.preventDefault();
        openDrawer();
        refreshCart().catch(function () {});
        return;
      }

      if (event.target.closest('[data-cart-close]')) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      var checkoutLink = event.target.closest('[data-cart-checkout]');
      if (checkoutLink) {
        var noteField = drawer.querySelector('[data-cart-note]');
        if (noteField && noteField.value !== lastSavedNote) {
          event.preventDefault();
          var checkoutUrl = checkoutLink.href;
          saveCartNote(noteField.value).then(function () {
            window.location.assign(checkoutUrl);
          }).catch(function () {});
        }
        return;
      }

      var quantityButton = event.target.closest('[data-cart-quantity]');
      if (!quantityButton) return;
      event.preventDefault();
      quantityButton.disabled = true;
      fetch(rootUrl + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: quantityButton.dataset.cartKey, quantity: Number(quantityButton.dataset.cartQuantityValue) })
      }).then(function (response) {
        if (!response.ok) throw new Error('Unable to update the cart.');
        return response.json();
      }).then(function (cart) {
        renderCart(cart);
      }).catch(function (error) {
        if (status) status.textContent = error.message;
      });
    });

    document.addEventListener('input', function (event) {
      if (!event.target.matches('[data-cart-note]')) return;
      window.clearTimeout(noteSaveTimer);
      setCartNoteStatus('Waiting to save...');
      noteSaveTimer = window.setTimeout(function () {
        saveCartNote(event.target.value).catch(function () {});
      }, 650);
    });

    document.addEventListener('focusout', function (event) {
      if (!event.target.matches('[data-cart-note]') || event.target.value === lastSavedNote) return;
      saveCartNote(event.target.value).catch(function () {});
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('form[action*="/cart/add"]');
      if (!form || event.defaultPrevented || form.dataset.ajaxSubmitting === 'true') return;
      event.preventDefault();
      form.dataset.ajaxSubmitting = 'true';

      var submitButton = event.submitter || form.querySelector('[type="submit"]');
      var originalText = submitButton ? submitButton.textContent : '';
      function restoreSubmitButton() {
        delete form.dataset.ajaxSubmitting;
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.classList.remove('is-loading');
          submitButton.textContent = originalText;
        }
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add('is-loading');
        submitButton.textContent = 'Adding...';
      }

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || 'Unable to add this item.');
          return data;
        });
      }).then(function (addedItem) {
        restoreSubmitButton();
        document.querySelectorAll('[data-cart-item-count]').forEach(function (node) {
          node.textContent = (Number(node.textContent) || 0) + (Number(addedItem.quantity) || 1);
        });
        openDrawer('Added to your cart.');
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: addedItem }));
        refreshCart('Added to your cart.').catch(function () {
          if (status) status.textContent = 'Added to your cart. Refresh to update the cart summary.';
        });
      }).catch(function (error) {
        restoreSubmitButton();
        openDrawer(error.message || 'Unable to add this item. Please try again.');
      });
    });
  }
})();
